// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tour-date-module--wrapper--3MDEf","venue":"tour-date-module--venue--1PNiV","glow":"tour-date-module--glow--6Fjbi"};